import React, { useState, useEffect, useRef } from "react";

import "./signup.css";
import SignupForm from "../components/forms/SignupForm";

const SignupPage = () => {
  return (
    <div className="signup-page">
      <header className="signup-title">Sign Up</header>
      <SignupForm />
    </div>
  );
}

export default SignupPage;